import { KlippekortOutline30Icon } from "@vygruppen/spor-icon-react";
import {
  ChecklistCustomTableStyle,
  EmptyTableText,
  GridStyled,
} from "features/CenterContent/RoleContent/VehicleChecklist/ChecklistCustomStyle";
import ChecklistTableRow from "features/CenterContent/RoleContent/VehicleChecklist/ChecklistTableRow";
import { VehicleSetVariant } from "features/CenterContent/RoleContent/VehicleChecklist/VehicleSetVariant";
import { Employee } from "features/CenterContent/RoleContent/VehicleChecklist/hooks/useEmployeeSearch";
import { FillOut } from "features/CenterContent/RoleContent/VehicleChecklist/schema/responseSchema";
import { FC } from "react";
import { ContentLoader, Text } from "shared/components/Spor";

interface ChecklistTableProps {
  fillouts: FillOut[];
  vehicleSetVariants: VehicleSetVariant[];
  employees: Employee[];
  totalFillOuts: number;
  loading: boolean;
  refetch: () => void;
}

const ChecklistTable: FC<ChecklistTableProps> = ({
  fillouts,
  vehicleSetVariants,
  employees,
  totalFillOuts,
  loading,
  refetch,
}) => (
  <ChecklistCustomTableStyle>
    <GridStyled>
      <Text>Utført</Text>
      <Text>Endret</Text>
      <Text>Kvittering</Text>
      <Text>Kjøretøy</Text>
      <Text>Kvittert av</Text>
      <Text>Endret av</Text>
      <Text textAlign="end" fontWeight="500" mr="12px">
        <span style={{ fontWeight: "bold" }}>{totalFillOuts}</span> Treff
      </Text>
    </GridStyled>

    {loading && <ContentLoader pt="20%" />}

    {!loading && fillouts.length === 0 && (
      <EmptyTableText>
        <KlippekortOutline30Icon mb="20px" />
        <Text variant="md" width="400px" textAlign="center">
          Søk på kjøretøy eller navn for å se tilhørende kvitteringer
        </Text>
      </EmptyTableText>
    )}

    {!loading &&
      fillouts.map((checklist) => (
        <ChecklistTableRow
          key={checklist.fillOutId}
          checklist={checklist}
          employees={employees}
          vehicleSetVariants={vehicleSetVariants}
          refetch={refetch}
        />
      ))}
  </ChecklistCustomTableStyle>
);

export default ChecklistTable;
